import { API_BASE } from "@/lib/api";

// Återanvänt Audio-element: webbläsare (särskilt iOS) blockerar new Audio()
// som skapas efter ett async-svar. Vi "primar" elementet synkront i själva
// skicka-gesten med en tyst wav, sedan får samma element spela riktiga ord.
let el = null;
const SILENT_WAV =
  "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA";

const ensureEl = () => {
  if (!el) {
    el = new Audio();
    el.preload = "auto";
  }
  return el;
};

// Anropas synkront i send-handlern (inne i klick/enter-gesten)
export const primeQuizAudio = () => {
  try {
    const a = ensureEl();
    if (!a.paused) return; // spelar redan ett ord — stör inte
    a.muted = true;
    a.src = SILENT_WAV;
    a.play().catch(() => {});
  } catch (_) { /* ljud är nice-to-have */ }
};

export const playQuizWord = (word) => {
  if (!word) return;
  try {
    const token = localStorage.getItem("grindstugatan_token") || "";
    const url = `${API_BASE}/api/jarvis/quiz-tts?text=${encodeURIComponent(word)}&token=${encodeURIComponent(token)}`;
    const a = ensureEl();
    a.muted = false;
    a.src = url;
    a.play().catch(() => {});
  } catch (_) { /* ljud är nice-to-have */ }
};
